<template>
  <div
    class="guests-input"
    aria-live="polite"
  >
    <MenuLabel
      class="guests-input__menu-label"
      :label="$t('STAY_CONFIRM_GUESTS_LABEL')"
      :isOpen="isOpen"
      :value="formatGuests"
      :last="isLast"
      @toggle="handleMenuToggled"
    />
    <component
      :is="$device.isMobile ? 'Drawer' : 'DropdownMenu'"
      :visible="isOpen"
      class="location-input__menu-container"
      :title="$t('STAY_GUESTS_HEADER')"
      @close="handleMenuToggled"
    >
      <div class="guests-input__input-wrapper">
        <InlineLabel label="Adults">
          <Stepper
            :value="selectedGuests.adults"
            @input="handleAdultsChanged"
            minimum="0"
          />
        </InlineLabel>
      </div>
      <div class="guests-input__input-wrapper">
        <InlineLabel :label="$t('STAY_CHILDREN_LABEL')">
          <Stepper
            :value="selectedGuests.children"
            @input="handleChildrenChanged"
            minimum="0"
          />
        </InlineLabel>
      </div>
      <template v-if="$device.isMobile" #footer>
        <ShButton @click="handleMenuToggled" :fullWidth="true">
          {{ $t('STAY_MODIFY_BOOKING_CONFIRM_CTA') }}
        </ShButton>
      </template>
    </component>
  </div>
</template>

<script>
import {
  DropdownMenu,
  MenuLabel,
  InlineLabel,
  Stepper,
  ShButton,
  Drawer
} from '@sohohouse/design-system'

import { getGuests } from '~/helpers'

export default {
  name: 'BedroomsGuestsMenu',
  components: {
    DropdownMenu,
    MenuLabel,
    InlineLabel,
    ShButton,
    Stepper,
    Drawer
  },

  props: {
    selectedGuests: {
      type: Object,
      default: () => ({
        adults: '',
        children: ''
      })
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    minimumNumberOfAdults () {
      return 1
    },

    formatGuests () {
      return getGuests(this.selectedGuests, this.$t.bind(this))
    }
  },

  methods: {
    handleAdultsChanged (number) {
      if (number < this.minimumNumberOfAdults) return
      this.$emit('change', {
        adults: number
      })
    },
    handleChildrenChanged (number) {
      this.$emit('change', {
        children: number
      })
    },
    handleMenuToggled () {
      this.$emit('menuToggle')
    }
  }
}
</script>

<style lang="scss" scoped>
$menu-border: 1px solid $color-gray-5;

.guests-input {
  position: relative;

  &__menu-label {
    border-top-width: 0;
    @include tablet {
      border-top-width: 1px;
    }
  }
  &__input-wrapper {
    padding: $space-040 $space-060;
  }
}
</style>
